import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import DataTable from '../../../Pages/InputField/TableLayout'; // Import the reusable DataTable component
import { FaEdit, FaTrash } from 'react-icons/fa';
import { Button, Row, Col } from 'react-bootstrap';
import './ReceiptsTable.css';
import { AuthContext } from "../../../Pages/Login/Context";
import baseURL from "../../../../Url/NodeBaseURL";

const ReceiptsTable = () => {
  const navigate = useNavigate(); // Initialize navigate function
  const [data, setData] = useState([]); // State to hold fetched data
  const { authToken, userId, userName, role } = useContext(AuthContext);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) return;

        const response = await fetch(`${baseURL}/permissions/${user.user_type_id}`);
        if (!response.ok) throw new Error('Failed to fetch permissions');

        const perms = await response.json();
        console.log('All permissions:', perms); // full object
        console.log('Reciepts permissions:', perms.permissions['Reciepts']); // correct path

        setPermissions(perms.permissions['Reciepts'] || {}); // Store only Customer Master permissions

      } catch (error) {
        console.error('Error fetching permissions:', error);
      }
    };

    fetchPermissions();
  }, []);

  const columns = React.useMemo(() => {
    const cols = [
      { Header: 'Sr. No.', Cell: ({ row }) => row.index + 1 },
      { Header: 'Date', accessor: 'date', Cell: ({ value }) => new Date(value).toLocaleDateString('en-IN') },
      { Header: 'Mode', accessor: 'mode' },
      { Header: 'Invoice No', accessor: 'invoice_number' },
      { Header: 'Receipt No', accessor: 'receipt_no' },
      { Header: 'Account Name', accessor: 'account_name' },
      { Header: 'Reference Number', accessor: 'cheque_number', Cell: ({ value }) => value || 'N/A' },
      { Header: 'Total Amt', accessor: 'total_amt' },
      { Header: 'Paid Amt', accessor: 'discount_amt' },
      { Header: 'Bal Amt', accessor: 'cash_amt' },
      { Header: 'Remarks', accessor: 'remarks' },
      {
        Header: 'Receipt',
        Cell: ({ row }) => (
          <a
            href={`${baseURL}/invoices/${row.original.receipt_no}.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            📝 View
          </a>
        ),
      },
    ];

    // Add Actions column based on permissions
    if (permissions.modify || permissions.delete) {
      cols.push({
        Header: 'Actions',
        accessor: 'actions',
        Cell: ({ row }) => (
          <div>
            {permissions.modify && (
              <FaEdit
                style={{ color: 'blue', cursor: 'pointer', marginRight: '10px' }}
                onClick={() => handleEdit(row.original.id, row.original.invoice_number)}
              />
            )}
            {permissions.delete && (
              <FaTrash
                style={{ color: 'red', cursor: 'pointer' }}
                onClick={() => handleDelete(row.original.id)}
              />
            )}
          </div>
        ),
      });
    }

    return cols;
  }, [permissions, data]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${baseURL}/get/receipts`);
        const result = await response.json();

        console.log("result=", result);

        if (result?.receipts) {
          setData(result.receipts); // directly set all receipts
        }
      } catch (error) {
        console.error("Error fetching receipts:", error);
      }
    };

    fetchData();
  }, []);


  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this Receipt?')) return;

    try {
      const response = await fetch(`${baseURL}/delete/receipt/${id}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        // Success message
        alert('Receipt deleted successfully');

        // Update state after successful deletion
        setData((prevData) => prevData.filter((payment) => payment.id !== id));
      } else {
        const result = await response.json();
        console.error('Error deleting Receipt:', result.message || 'Unknown error');
        alert(result.message || 'Failed to delete Receipt. Please try again.');
      }
    } catch (error) {
      console.error('Error deleting Receipt:', error);
      alert('An error occurred while deleting the Receipt. Please try again.');
    }
  };

  const handleEdit = (id) => {
    // navigate('/receipts', { state: { repairData: rowData } });
    navigate(`/receipts/${id}`);
  };

  // const handleEdit = (id, invoiceNumber) => {
  //   if (invoiceNumber && invoiceNumber.startsWith("SMJ")) {
  //     navigate(`/receipts/${id}`);
  //   } else {
  //     navigate(`/orderreceipts/${id}`);
  //   }
  // };


  const handleCreate = () => {
    navigate('/receipts'); // Navigate to the payments creation page
  };

  return (
    <div className="main-container">
      <div className="receipt-table-container">
        <Row className="mb-3">
          <Col className="d-flex justify-content-between align-items-center">
            <h3>Receipts</h3>
            {permissions.add && (
              <Button
                className="create_but"
                onClick={handleCreate}
                style={{ backgroundColor: '#a36e29', borderColor: '#a36e29' }}
              >
                + Create
              </Button>
            )}
          </Col>
        </Row>

        <DataTable columns={columns} data={[...data].reverse()} />

      </div>
    </div>
  );
};

export default ReceiptsTable;
